import PropTypes from 'prop-types';
import React from 'react';
import ToolTip from '../../../Elements/ToolTip/ToolTip';

import './MobileIndustrialTable.scss';

export default class MobileIndustrialTable extends React.PureComponent {
    constructor(props) {
        super(props);
        this.tooltipMedian = [];
        this.tooltipAverage = [];
    }

    static propTypes = {
        /**
         * array of row data
         */
        rowRecords: PropTypes.arrayOf(
            PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.string,
                    description: PropTypes.string,
                })
            )
        ),
    };

    static defaultProps = {
        rowRecords: [],
    };

    renderSingleRow = (rowRecord, rowNum) => {
        if (rowRecord.length > 0) {
            let bgColor = rowNum % 2 !== 0 ? 'gray-background' : '';

            return (
                <div
                    className={`mobile-industrial-row p-3 ${bgColor}`}
                    key={rowNum}
                >
                    <div>
                        <strong>{rowRecord[0].data}</strong>
                    </div>

                    <div>
                        Median: &nbsp;
                        <span
                            style={{ position: 'relative' }}
                            className="record"
                            onMouseOver={(e) => {
                                this.tooltipMedian[rowNum].show(e);
                            }}
                            onTouchStart={(e) => {
                                this.tooltipMedian[rowNum].show(e);
                            }}
                        >
                            {rowRecord[1].data}

                            <ToolTip
                                ref={(node) => {
                                    this.tooltipMedian[rowNum] = node;
                                }}
                                type=""
                                direction="up"
                            >
                                {rowRecord[1].description}
                            </ToolTip>
                        </span>
                    </div>

                    {
                        <div>
                            Average: &nbsp;
                            <span
                                style={{ position: 'relative' }}
                                className="record"
                                onMouseOver={(e) =>
                                    this.tooltipAverage[rowNum].show(e)
                                }
                                onTouchStart={(e) =>
                                    this.tooltipAverage[rowNum].show(e)
                                }
                            >
                                {rowRecord[2].data}

                                <ToolTip
                                    ref={(node) => {
                                        this.tooltipAverage[rowNum] = node;
                                    }}
                                    type=""
                                    direction="up"
                                >
                                    {rowRecord[2].description}
                                </ToolTip>
                            </span>
                        </div>
                    }
                </div>
            );
        }
    };

    render() {
        return (
            <div className="component-Employer-Benefits-MobileIndustrialTable">
                {this.props.rowRecords.map((rowRecord, idx) =>
                    this.renderSingleRow(rowRecord, idx)
                )}
            </div>
        );
    }
}
